import styled from "styled-components"
import format from "date-fns/format"
import { pl } from "date-fns/locale"

const BlogListItemStyled = styled.a`
  margin: 16px;
  background-color: white;
  box-shadow: 0 0 20px rgba(100, 100, 100, 0.1);
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  padding: 16px;

  transition: background-color 0.15s ease;
  cursor: pointer;
  text-decoration: none !important;
  color: initial !important;

  :hover {
    background-color: #fafafa;
  }

  .left {
    width: 30%;
    min-height: 250px;
    .photo {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    flex: 1;
    padding: 8px;
    .title {
      font-weight: bold;
      font-size: 16px;
    }

    .summary {
      font-size: 12px;
    }
  }
`

export const BlogListItem = ({ title, link, summary, imgUrl, publishedAt }) => {
  return (
    <BlogListItemStyled href={`/inspiracje/${link}`}>
      <div className="left">
        <div className="photo">
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            src={imgUrl}
          />
        </div>
      </div>
      <div className="right">
        <div className="title">{title}</div>
        <div className="summary"> {summary}</div>
      </div>
      <div>
        {publishedAt && (
          <div className="date">
            {format(new Date(publishedAt), "yyyy | d LLLL", {
              locale: pl,
            })}
          </div>
        )}
      </div>
    </BlogListItemStyled>
  )
}
